/* eslint-disable no-unused-vars */

import React, { useEffect, useRef, useState } from 'react';
import { Map, AdvancedMarker } from '@vis.gl/react-google-maps';
import { useDispatch, useSelector } from 'react-redux';

import MarkerIcon from './marker-icon';
import Icon from '@components/icon-component';

import { siteMapActions } from '@redux/slices/site-map';
import { GOOGLE_MAP_ID } from '@utilities/app-urls';
import useWindowDimensions from '@hooks/useWindowDimensions';
import style from './style.module.scss';

const GoogleMap = ({
  defaultCenterCoordinate,
  siteCoordinateList,
  selectedSiteId,
  selectedSiteCenterCoordinate,
  selectedSiteIndex,
  open,
  list,
  detailPage,
  siteChildrenList
}) => {
  const dispatch = useDispatch();
  const markerIconRefs = useRef([]);
  const mapRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const { width, height } = useWindowDimensions();

  const { bottomSiteCardHeightWithIndexes = {} } = useSelector((state) => state.siteMap) || {};

  const containerStyle = {
    width: '100%',
    height: `calc(100svh - ${width <= 768 ? 223 : 168}px)`
  };

  useEffect(() => {
    if (mapRef?.current?.map && mapRef?.current?.map?.setCenter && !loading) {
      if (selectedSiteId && selectedSiteCenterCoordinate?.latitude) {
        mapRef?.current?.map.setCenter({
          lat: selectedSiteCenterCoordinate?.latitude || 0,
          lng: selectedSiteCenterCoordinate?.longitude || 0
        });
      } else {
        mapRef?.current?.map.setCenter({
          lat: defaultCenterCoordinate?.latitude || 0,
          lng: defaultCenterCoordinate?.longitude || 0
        });
      }
    }
  }, [selectedSiteId, mapRef, selectedSiteCenterCoordinate, defaultCenterCoordinate, loading]);

  const clickSiteMarker = ({ siteId, index }) => {
    dispatch(
      siteMapActions.setSelectedSiteIdOnMapView({
        siteId: siteId,
        // selectedSiteId && selectedSiteId === siteId ? null :
        siteIndex: index
        // selectedSiteId && selectedSiteId === siteId ? -1 :
      })
    );

    if (siteId) {
      const item = document.querySelector('[data-index="0"]');
      const selectedCardHeight = item?.clientHeight || 0;

      const virtualListModalContainer = document.getElementById('virtual-list-modal-container');
      const virtualListModalContainer1 = document.getElementById('react-swipeable-virtual-list');
      if (virtualListModalContainer1) {
        virtualListModalContainer1.scrollTo(0, 0);
        virtualListModalContainer1.scrollIntoView({ behavior: 'smooth' });
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }

      const listContainer = document.getElementById('list-container');
      if (virtualListModalContainer && listContainer) {
        if (width < 1025 && width >= 768) {
          virtualListModalContainer.style.top = `calc(100svh - ${77 + selectedCardHeight}px)`;
          let xoo = height - (selectedCardHeight + 171);
          listContainer.style.height = `calc(100svh - ${xoo + 171}px)`;
        } else if (width <= 767) {
          virtualListModalContainer.style.top = `calc(100svh - ${159 + selectedCardHeight}px)`;
          let xoo = height - (selectedCardHeight + 297);
          listContainer.style.height = `calc(100svh - ${xoo + 297}px)`;
        }
      }

      if (detailPage) {
        const siteCardContainerBottom = document?.getElementById('site-card-container-bottom');
        if (siteCardContainerBottom) {
          let siteList =
            siteChildrenList?.length > 0
              ? siteId
                ? [
                    ...siteChildrenList.filter((x) => x?.siteId === siteId),
                    ...siteChildrenList.filter((x) => x?.siteId !== siteId)
                  ]
                : siteChildrenList
              : [];

          siteCardContainerBottom.style.top = `calc(100svh - ${
            siteId
              ? bottomSiteCardHeightWithIndexes[siteList.findIndex((x) => x?.siteId === siteId)]
              : 0
          }px)`;
        }
      }
    }
  };

  const resetToOriginalPosition = () => {
    if (markerIconRefs.current) {
      markerIconRefs.current[selectedSiteIndex]?.clearSelectedIcon();
    }

    if (selectedSiteId) {
      dispatch(
        siteMapActions.setSelectedSiteIdOnMapView({
          siteId: null,
          siteIndex: -1
        })
      );
    } else {
      mapRef?.current?.map.setCenter({
        lat: defaultCenterCoordinate?.latitude || 0,
        lng: defaultCenterCoordinate?.longitude || 0
      });
    }
  };

  const outsideClickEvent = () => {
    if (list?.length > 0 && open) {
      const virtualListModalContainer = document.getElementById('virtual-list-modal-container');
      const listContainer = document.getElementById('list-container');

      if (virtualListModalContainer && listContainer) {
        virtualListModalContainer.removeAttribute('style');
        listContainer.removeAttribute('style');

        if (width <= 767) {
          virtualListModalContainer.style.top = 'calc(100svh - 77px)';
        }
        if (width <= 1024) {
          virtualListModalContainer.style.top = 'calc(100svh - 159px)';
        }
      }
    }

    if (detailPage) {
      const googleMapOfAssetDetailPage = document?.getElementById('google-map-asset-page');
      const siteCardContainerBottom = document?.getElementById('site-card-container-bottom');

      if (googleMapOfAssetDetailPage && siteCardContainerBottom) {
        const previousHeight = googleMapOfAssetDetailPage?.getAttribute('data-height') || 0;
        const currentScrollPosition =
          googleMapOfAssetDetailPage?.getAttribute('current-scroll-position') || 0;

        googleMapOfAssetDetailPage.style.height = `calc(100vh - ${
          previousHeight - currentScrollPosition
        }px)`;

        siteCardContainerBottom.removeAttribute('style');
      }
    }
  };

  return (
    <div className={style.maoContainer}>
      <Map
        id="google-map-asset-page"
        style={containerStyle}
        defaultCenter={{
          lat: defaultCenterCoordinate?.latitude || 0,
          lng: defaultCenterCoordinate?.longitude || 0
        }}
        defaultZoom={12}
        minZoom={5}
        gestureHandling={'greedy'}
        disableDefaultUI={true}
        mapId={GOOGLE_MAP_ID}
        onTilesLoaded={(event) => {
          mapRef.current = { map: event?.map };

          loading &&
            event?.map.setCenter({
              lat: defaultCenterCoordinate?.latitude || 0,
              lng: defaultCenterCoordinate?.longitude || 0
            });
          setLoading(false);
        }}
        onClick={outsideClickEvent}
      >
        <AdvancedMarker
          position={{
            lat: defaultCenterCoordinate?.latitude || 0,
            lng: defaultCenterCoordinate?.longitude || 0
          }}
        >
          <Icon name={'current-location-marker'} width={34} height={34} />
        </AdvancedMarker>

        {siteCoordinateList?.map((marker, index) => {
          return (
            <AdvancedMarker
              position={{ lat: marker?.latitude, lng: marker?.longitude }}
              key={index}
              onClick={() => {
                clickSiteMarker({ siteId: marker?.siteId, index });
              }}
            >
              <MarkerIcon
                count={marker?.totalTask}
                iconName={marker?.iconName}
                selectedIconName={marker?.selectedIconName}
                selectedSiteId={selectedSiteId}
                siteIdCurrent={marker?.siteId}
                ref={(childRef) => (markerIconRefs.current[index] = childRef)}
                // clickEvent={() => clickSiteMarker({ siteId: marker?.siteId, index })}
              />
            </AdvancedMarker>
          );
        })}
      </Map>

      {!detailPage && (
        <button onClick={resetToOriginalPosition} className={style.googleDefaultCenterIcon}>
          <Icon name={'google-map-center'} height={16} width={16} />
        </button>
      )}
    </div>
  );
};

export default GoogleMap;
